import Header from "../../components/Header/Header";
import iconTelWhite from "../../assets/icon_tel_wh.svg";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import useReactGASend from "../../hooks/useReactGASend";
import React from "react";

// TODO: 확인 필요 - 기존 온라인샵 URL(store.ssglanders.com, landers.mfamily.ssg.com, 스마트스토어, landerscorestore.co.kr)은 엑셀에 없고 고객센터 전화만 있어 전화 버튼으로 교체
const goodsCenterButtons = [
  {
    title: "랜더스 플래그십 스토어 및 랜더스샵 by emart 온라인 스토어",
    link: "tel:1577-3419",
    isPhoneLink: true,
  },
  {
    title: "랜더스 플래그십 스토어 오프라인 스토어",
    link: "tel:032-717-1180",
    isPhoneLink: true,
  },
  {
    title: "랜더스샵 by emart 오프라인 스토어",
    link: "tel:032-218-1234",
    isPhoneLink: true,
  },
  {
    title: "랜더스샵 by CORE",
    link: "tel:070-5224-1969",
    isPhoneLink: true,
  },
];

const centerGuide = `[고객센터]
• 랜더스 플래그십 스토어 및 랜더스샵 by emart 온라인 스토어(1577-3419)
• 랜더스 플래그십 스토어 오프라인 스토어(032-717-1180)
• 랜더스샵 by emart 오프라인 스토어(032-218-1234)
• 랜더스샵 by CORE 온/오프라인 스토어(070 -5224 -1969)`;

const introText = `굿즈 구매/배송 및 교환/불량 문의는 해당 굿즈샵 고객센터를 통해 상담 가능합니다.

[오프라인 굿즈샵(인천SSG랜더스필드 내 위치)]
• 랜더스 플래그십 스토어
- 위치 : 1층 1루 방면 스타벅스 게이트 옆(구장 내부)
- 운영 시간 : 홈경기 게이트 오픈시간~경기 종료 후 30분

• 랜더스샵 by emart
- 위치 : 외야 게이트(GATE 7) 옆(구장 외부)
- 운영시간 : 홈경기 게이트 오픈시간~경기 종료 후 30분
* 비홈경기 운영시간 : 화~토 11시~18시(점심시간 : 12시 30분~13시 30분)

• 랜더스샵 by CORE
- 위치 : 1층 중앙 랜더스센터 옆(구장 내부)
- 운영시간 : 홈경기 게이트 오픈시간~경기 종료 후 30분

${centerGuide}

※ 아래 버튼을 통해 통해 각 굿즈샵 고객센터로 연결 가능합니다.`;

const common = [
  {
    title: "포토카드는 어떻게 구매하나요?",
    content:
      "포토카드는 인천SSG랜더스필드 내 포토카드존에 설치된 키오스크를 통해 구매 가능합니다.\n\n- 판매 위치 : 내야 2층 포토카드 존, 외야 7번 게이트 옆 포토카드 존\n- 운영 기간 : 정규 시즌 홈경기\n- 판매 시간 : 개문 ~ 경기종료 후 30분\n- 이용 요금 : 포토카드 5,000원(카드 결제)",
  },
  {
    title: "구매한 유니폼이 불량이에요.",
    content:
      `유니폼 구매 후 교환/불량 문의는 각 굿즈샵 고객센터를 통해 상담 가능합니다.\n\n${centerGuide}\n\n※ 아래 버튼을 통해 통해 각 굿즈샵 고객센터로 연결 가능합니다.`,
    buttons: goodsCenterButtons,
  },
  {
    title: "유니폼 배송은 언제 오나요?",
    content:
      `유니폼/굿즈 판매 및 배송은 각 운영사에서 관리되고 있어 구매하신 굿즈샵 고객센터를 통해 확인 가능합니다.\n\n${centerGuide}\n\n※ 아래 버튼을 통해 통해 각 온라인 굿즈샵 고객센터로 연결 가능합니다.`,
    buttons: goodsCenterButtons,
  },
  {
    title: "열 부착 마킹은 어디에서 하나요?",
    content:
      `구매한 유니폼의 마킹지는 각 구매처에서 열 부착 마킹이 가능합니다.\n\n[오프라인 굿즈샵(인천SSG랜더스필드 내 위치)]\n• 랜더스 플래그십 스토어\n- 위치 : 1층 1루 방면 스타벅스 게이트 옆(구장 내부)\n- 운영 시간 : 홈경기 게이트 오픈시간~경기 종료 후 30분\n\n• 랜더스샵 by emart\n- 위치 : 외야 게이트(GATE 7) 옆(구장 외부)\n- 운영시간 : 홈경기 게이트 오픈시간~경기 종료 후 30분\n* 비홈경기 운영시간 : 화~토 11시~18시(점심시간 : 12시 30분~13시 30분)\n\n• 랜더스샵 by CORE\n- 위치 : 1층 중앙 랜더스센터 옆(구장 내부)\n- 운영시간 : 홈경기 게이트 오픈시간~경기 종료 후 30분\n\n※ 열 마킹은 굿즈샵 운영 시간 내 구매처 별로 가능합니다.\n※ 열 마킹 관련 자세한 문의는 각 굿즈샵 고객센터로 문의 부탁드립니다.\n\n${centerGuide}`,
    buttons: goodsCenterButtons,
  },
];

export const AccordionItemComponent = ({
  item,
  index,
}) => (
  <AccordionItem
    key={index}
    itemKey={index}
    className="mb-2"
    header={({state}) => 
      <div className={`flex items-center w-full pb-2 text-lg font-semibold text-gray-950 border border-[#D1D5DB] p-2.5 bg-white text-left ${state.isEnter ? 'rounded-bl-none rounded-br-none rounded-tl-[30px] rounded-tr-[30px] border-none' : 'rounded-full'}`}>
        <span
          className={`inline-flex items-center justify-center p-3 h-10 bg-black shadow-md rounded-full text-white text-2xl font-semibold shrink-0 mr-2`}
        >
          Q
        </span>
        {item.title}
      </div>
    }
  >
  {({state}) => 
    <div className={`p-6 border rounded-3xl border-[#D1D5DB] bg-white ${state.isEnter && 'rounded-tl-none rounded-tr-none border-none mt-[-10px]'}`}>
      <p className="font-medium text-gray-950 whitespace-pre-line">{item.content}</p>
      {item.buttons && (
        <div className="flex justify-center flex-col">
          {item.buttons.map((button) => (
            <LinkItem
              key={button.title}
              title={button.title}
              url={button.link}
              isPhoneLink={button.isPhoneLink}
              styles={"mx-2"}
            />
          ))}
        </div>
      )}
    </div>
  } 
  </AccordionItem>
);


export const LinkButton = ({
  url,
  className,
  imgSrc,
  altText,
  buttonText,
  onClick,
}) => (
  <a
    onClick={onClick}
    href={url}
    className={className}
  >
    <span className="shrink-0">
      <img src={imgSrc} alt={altText} />
    </span>
    <span className="flex-1 text-center">{buttonText}</span>
  </a>
);

export const LinkItem = ({ title, url, isPhoneLink, onClick, styles }) => (
  <li className="pt-4 list-none">
    <a
      onClick={onClick}
      href={url}
      target={isPhoneLink ? undefined : "_blank"}
      rel={isPhoneLink ? undefined : "noopener noreferrer"}
      className={`flex items-center bg-[#FFFFFF] ${
        isPhoneLink ? "gap-4" : ""
      } justify-center min-h-12 h-auto px-4 py-2 text-center text-sm leading-snug rounded-[16px] ${
        isPhoneLink ? "border-2" : "border"
      } border-[#FFA2A2] text-[#CE152D] font-semibold ${styles}`}
    >
      {title}
    </a>
  </li>
);


const MDPage = () => {
  const { makeEventTrackFn } = useReactGASend();
  const trackButtonClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };

  return (
    <section className="p-hasHeader">
      <Header title="MD" />
      <div className="bg-white p-7 rounded-3xl mb-6 font-medium text-base mt-2 text-gray-950 whitespace-pre-line">
        {introText}
        {goodsCenterButtons.map((button) => (
          <LinkItem
            key={button.title}
            title={button.title}
            url={button.link}
            isPhoneLink
            onClick={() => trackButtonClick(`굿즈_${button.title}`)}
          />
        ))}
      </div>

      <Accordion transition transitionTimeout={250}>
        {common.map((item, index) => (
          <AccordionItemComponent
            key={index}
            item={item}
            index={index}
          />
        ))}
      </Accordion>

      <div className="flex flex-col items-center mt-10 bg-white p-5 rounded-3xl justify-center w-full ">
        <div className="text-base font-medium text-[#4A5565] pb-2 flex text-center justify-center">추가적인 도움이 필요하신가요?</div>
        <LinkButton
          url="tel:032-455-2600"
          className="flex items-center justify-between w-36 h-9 bg-brand-secondary rounded-[30px] text-white px-6 py-6 text-sm font-medium mb-1.5"
          imgSrc={iconTelWhite}
          buttonText="전화상담"
          onClick={() => trackButtonClick("굿즈_전화상담")}
        />
      </div>
    </section>
  );
};

export default MDPage;
